﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Circle from 'ol/geom/Circle.js';
import Feature from 'ol/Feature.js';
import Collection from 'ol/Collection.js';
import VectorSource from 'ol/source/Vector.js';
import { Utility } from '../Utility.js';
import { Upload } from '../upload.js';
export { PatrimonyTool };

/**
 * Class DepositionPointTool
 */
const PatrimonyTool = function () {

    // Define this
    var myPatrimonyTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Upload attachment
    this._uploadAttachtment = null;

    // Already initialize
    this._toolInitialize = false;

    // Hash that contains all reference 
    this._hashReference = {};

    // Feature to save
    this._featureInfo = null;

    // Geojson Format
    this._geojsonFormat = new GeoJSON();

    // Tipos Description table counter/id
    this._DescriptionsRowCounter = 0;

    // Producer table counter/id
    this._producerRowCounter = 0;

    // Intervenções table counter/id
    this._intervencoesRowCounter = 0;

    // Observações table counter/id
    this._observacoesRowCounter = 0;

    // Layer information used in deposition point tool
    this._layerInformation = {};

    // Radius deposition search
    this._radiusSearch = 200;

    // Type deposition point to change compartimento
    this._idTypeDepositionCompartimento = "2";

    // Object with the entity selected for producer
    this._entitySelectedForProducer = null;

    // Deposition point identifier column name
    this._depositionPointIdColumnName = "";

    // Datatable available inventory
    this._datatableAvailableInventory = null;

    // Datatable associate inventory
    this._datatableAssociateInventory = null;

    // Datatable available flat inventory
    this._datatableAvailableFlatInventory = null;

    // Datatable associate inventory
    this._datatableSameInventory = null;

    // Datatable associate inventory
    this._datatableBuildingFlat = null;

    // Equipment datatable
    this._equipmentDatatable = null;
    this._equipmentDpDatatable = null;
    this._producerDatatable = null;
    this._typeEquipmentDatatable = null;
    this._equipmentInterventionDatatable = null;
    this._depositionPointObservationDatatable = null;

    this._layersRefresh = ['EDIFICIOS', 'EDIFICIOSALIENADOS'];

    // Hash for reference combo
    this._hashReferenceCombo = {
        section: {}
    };

    this._canvasHtml = null;

    this._layerNameAjax = "";

    /**
     * Build detail information for deposition point
     * @param {object} featureInfo, all information of the pub
     */
    this.DetailElement = function (featureInfo)
    {
        $('.hide-patrimony-building-flat').hide();
        $('.show-patrimony-building-flat').show();

        // Get inventory field information
        myPatrimonyTool._canvasHtml = myPatrimonyTool._utility.GetPropertyInfoInConfigArray(myPatrimonyTool._mapSgs._settings.configurationInfo.propertyInfo, "PATRIMONY", "EDIFICIOS", "LAYER_JSON");

        var idFeature = featureInfo.feature.getId();
        var typeOfElement = "";
        var idElement = null;
        if (idFeature) {
            var arrayElementIdInfo = featureInfo.feature.getId().split(".");
            // Type of element
            typeOfElement = arrayElementIdInfo[0];
            $('#id-patrimony-type-element').val(typeOfElement);

            // Id element
            idElement = arrayElementIdInfo[1];
            $('#id-patrimony-id-element').val(idElement);
        }
        else {
            typeOfElement = featureInfo.layerName;
        }

        var JSONDetail = JSON.parse(myPatrimonyTool._canvasHtml.value);

        $('#id-patrimony-to-edit').val(featureInfo.id);

        myPatrimonyTool._featureInfo = featureInfo;

        // If permission to edit then transform read on update
        if (myPatrimonyTool._mapSgs._settings._mapSettings.operation_visible.EditLayers) {
            if (featureInfo.mode === 'read')
                featureInfo.mode = 'update';
        }

        myPatrimonyTool._hashReference['equipamentos_list'] = [];
        myPatrimonyTool._hashReference['intervencoes_list'] = [];
        myPatrimonyTool._hashReference['observacoes_list'] = [];
        var codElement = "";

        // Start wait
        myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', true);

        // Clean Number of file
        $('.offcanvas-body-layer-detail-attachment-info-td span')[0].innerHTML = "-";

        // Define according to mode
        var readOnly = "readonly";
        var hiddenCol = false;
        switch (featureInfo.mode) {
            case 'update':
                // ajust button
                $('#id-offcanvas-body-layer-detail-button-patrimony').removeClass('ol-hidden');
                $('#id-save-feature-submit-patrimony').removeClass('col-md-12');
                $('#id-save-feature-submit-patrimony').addClass('col-md-6');
                $('#id-delete-feature-submit-zone-patrimony').removeClass('ol-hidden');

                // Event save feature
                $('#id-save-feature-submit-patrimony').off('click').on('click', function () {
                    myPatrimonyTool._SaveFeature(featureInfo.mode, featureInfo.fromMap, featureInfo.feature.id_.split('.')[0]);
                });

                // Event delete feature
                $('#id-delete-feature-submit-patrimony').off('click').on('click', function () {
                    var idPatrimony = $('#id-patrimony-to-edit').val();
                    myPatrimonyTool._DeleteFeature(idPatrimony, featureInfo.feature.id_.split('.')[0]);
                });

                $('#id-offcanvas-body-layer-data').remove();

                readOnly = "";
                break;
            case 'create':
                // Ajust button
                $('#id-offcanvas-body-layer-detail-button-patrimony').removeClass('ol-hidden');
                $('#id-save-feature-submit-patrimony').removeClass('col-md-6');
                $('#id-save-feature-submit-patrimony').addClass('col-md-12');
                $('#id-delete-feature-submit-zone-patrimony').addClass('ol-hidden');

                $.ajax({
                    type: 'GET',
                    url: '/rest/app/PatrimonyTool/GetLayerNameById?id=' + featureInfo.idLayer,
                    dataType: 'json',
                    async: false,
                    contentType: "application/json",
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na criação");
                        }
                        else
                        {
                            myPatrimonyTool._layerNameAjax = data.result;

                            if (data.result == "EDIFICIOS")
                            {
                                readOnly = "";

                                let container = $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12');

                                // -- Details -------------------------------------------------------------------------------
                                $('#id-offcanvas-body-layer-data').remove();

                                let localContentLocal = '<div id="id-offcanvas-body-layer-detail-data" class="offcanvas-block" style="display: none;">'
                                    + '<div class="table-responsive">'
                                    + '<form id="id-modal-body-detail-form">'
                                    + '<div id="id-offcanvas-body-detail-container" class="body table-responsive">'
                                    + '</div>'
                                    + '</form>'
                                    + '</div>'
                                    + '</div>';

                                container.append('<div id="id-offcanvas-body-layer-data" class="row margin-top-lg offcanvas-body-layer-detail">'
                                    + '<div class="col-md-12">'
                                    + '<div>'
                                    + '<div target-id="id-offcanvas-body-layer-detail-data" class="offcanvas-collapse">'
                                    + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                                    + '<label>Dados Edificio</label>'
                                    + '</div>'
                                    + localContentLocal
                                    + '</div>'
                                    + '<div class="offcanvas-separator"></div>'
                                    + '</div>'
                                    + '</div>');


                                $('#id-offcanvas-body-detail-container').append($(
                                    '<div class="form-group offcanvas-body-layer-detail-row">'
                                    + '<label for="prop_estatuto">Estatuto</label>'
                                    + '<input class=" feature-field form-control" data-name="ESTATUTO" type="text" id="prop_estatuto"/>'
                                    + '</div > '
                                ));


                                $('#id-offcanvas-body-detail-container').append($(
                                    '<div class="form-group offcanvas-body-layer-detail-row">'
                                    + '<label for="prop_ID">ID</label>'
                                    + '<input class=" feature-field form-control" data-name="ID" type="number" id="prop_ID"/>'
                                    + '</div > '
                                ));

                                $('#id-div-canvas-body-detail-patrimony .offcanvas-collapse').off('click').on('click', function (e) {

                                    e.preventDefault();

                                    var IconHtml = $(this).find('i')[0]

                                    var targetId = this.getAttribute('target-id');

                                    $('#' + targetId).toggle('ol-hidden')

                                    if ($(IconHtml).hasClass('fa-chevron-down'))
                                        $($(this).find('i')[0]).removeClass('fa-chevron-down').addClass('fa-chevron-up')
                                    else
                                        $($(this).find('i')[0]).removeClass('fa-chevron-up').addClass('fa-chevron-down')

                                });

                                // Event create feature
                                $('#id-save-feature-submit-patrimony').off('click').on('click', function () {
                                    myPatrimonyTool._SaveFeature(featureInfo.mode, featureInfo.fromMap, myPatrimonyTool._layerNameAjax);
                                });

                            }
                            else if (data.result == "TERRENOS") {

                                readOnly = "";

                                let container = $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12');

                                // -- Details -------------------------------------------------------------------------------
                                $('#id-offcanvas-body-layer-data').remove();

                                let localContentLocal = '<div id="id-offcanvas-body-layer-detail-data" class="offcanvas-block" style="display: none;">'
                                    + '<div class="table-responsive">'
                                    + '<form id="id-modal-body-detail-form">'
                                    + '<div id="id-offcanvas-body-detail-container" class="body table-responsive">'
                                    + '</div>'
                                    + '</form>'
                                    + '</div>'
                                    + '</div>';

                                container.append('<div id="id-offcanvas-body-layer-data" class="row margin-top-lg offcanvas-body-layer-detail">'
                                    + '<div class="col-md-12">'
                                    + '<div>'
                                    + '<div target-id="id-offcanvas-body-layer-detail-data" class="offcanvas-collapse">'
                                    + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                                    + '<label>Dados terreno</label>'
                                    + '</div>'
                                    + localContentLocal
                                    + '</div>'
                                    + '<div class="offcanvas-separator"></div>'
                                    + '</div>'
                                    + '</div>');


                                $('#id-offcanvas-body-detail-container').append($(
                                    '<div class="form-group offcanvas-body-layer-detail-row">'
                                    + '<label for="prop_estatuto">Estatuto</label>'
                                    + '<input class=" feature-field form-control" data-name="ESTATUTO" type="text" id="prop_ESTATUTO"/>'
                                    + '</div > '
                                ));


                                $('#id-offcanvas-body-detail-container').append($(
                                    '<div class="form-group offcanvas-body-layer-detail-row">'
                                    + '<label for="prop_alvara">Alvara</label>'
                                    + '<input class=" feature-field form-control" data-name="ALVARA" type="text" id="prop_ALVARA"/>'
                                    + '</div > '
                                ));


                                $('#id-offcanvas-body-detail-container').append($(
                                    '<div class="form-group offcanvas-body-layer-detail-row">'
                                    + '<label for="prop_type-ground">Tipo terreno</label>'
                                    + '<input class=" feature-field form-control" data-name="type-ground" type="text" id="prop_type-ground"/>'
                                    + '</div > '
                                ));

                                $('#id-offcanvas-body-detail-container').append($(
                                    '<div class="form-group offcanvas-body-layer-detail-row">'
                                    + '<label for="prop_ID">ID</label>'
                                    + '<input class=" feature-field form-control" data-name="ID" type="number" id="prop_ID"/>'
                                    + '</div > '
                                ));

                                $('#id-div-canvas-body-detail-patrimony .offcanvas-collapse').off('click').on('click', function (e) {

                                    e.preventDefault();

                                    var IconHtml = $(this).find('i')[0]

                                    var targetId = this.getAttribute('target-id');

                                    $('#' + targetId).toggle('ol-hidden')

                                    if ($(IconHtml).hasClass('fa-chevron-down'))
                                        $($(this).find('i')[0]).removeClass('fa-chevron-down').addClass('fa-chevron-up')
                                    else
                                        $($(this).find('i')[0]).removeClass('fa-chevron-up').addClass('fa-chevron-down')

                                });

                                // Event create feature
                                $('#id-save-feature-submit-patrimony').off('click').on('click', function () {
                                    myPatrimonyTool._SaveFeature(featureInfo.mode, featureInfo.fromMap, myPatrimonyTool._layerNameAjax);
                                });

                            }

                        }
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na criação");
                    }
                });

                break;
            default: // read
                $('#id-offcanvas-body-layer-detail-button-patrimony').addClass('ol-hidden');
        }

        var typeElement = $('#id-patrimony-type-element').val();
        myPatrimonyTool._buildHtmlInventory(featureInfo.feature.values_.INVENTARIO, JSONDetail, typeElement, featureInfo.mode);

        // Layer info
        var layerObj = myPatrimonyTool._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;
        var layerPrettyName = layerObj.layer_info.pretty_name;

        // Get codElement
        if (featureInfo.feature.getProperties().import_code)
            codElement = featureInfo.feature.getProperties().import_code;

        // Build title
        $('#id-offcanvas-head-title-element-patrimony')[0].innerHTML = layerObj.layer_info.pretty_name;
        $('#id-offcanvas-head-code-element-patrimony')[0].innerHTML = codElement;

        if (featureInfo.feature.values_.INVENTARIO)
        {
            $('#id-patrimony-inventory-building-of-flat').val(featureInfo.feature.values_.INVENTARIO);
            myPatrimonyTool._GetDataInventoryInfo(featureInfo.feature.values_.INVENTARIO, typeOfElement, idElement);
        }
        else
        {
            myPatrimonyTool._EventsOnClick();
            myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
        }

        // Show canvas
        myPatrimonyTool._utility.ShowOpenCanvas3('id-offcanvas-layer-detail-patrimony', true);

        // -- File --------------------------------------------------------------------------------

        //// Init Upload for entity
        if (myPatrimonyTool._mapSgs._uploadAttachtment)
            myPatrimonyTool._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone-patrimony', 'id-offcanvas-body-layer-detail-attachment-form-patrimony', 'id-offcanvas-body-layer-detail-attachment-add-patrimony', 'offcanvas-body-layer-detail-attachment-info-td-patrimony', 'id-offcanvas-body-layer-detail-attachment-spinner-patrimony');

    };

    /**
     * Build enventory information selected
     */
    $('#id-modal-select-new-id-inv-select').on('click', function () {

        // Stop wait
        myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', true);

        var selectedAvailableInventory = myPatrimonyTool._datatableAvailableInventory.rows('.selected').data();
        var selectedAssociateInventory = myPatrimonyTool._datatableAssociateInventory.rows('.selected').data();

        if (selectedAvailableInventory.length == 0 && selectedAssociateInventory.length == 0) {
            toastr["warning"]("Seleccione um inventário");
            return;
        }
        if (selectedAvailableInventory.length > 1 || selectedAssociateInventory.length > 1) {
            toastr["warning"]("Seleccione apenas um inventário");
            return;
        }

        var selectedInventory = (selectedAvailableInventory.length == 1) ? selectedAvailableInventory : ((selectedAssociateInventory == 1) ? selectedAssociateInventory : null);
        if (!selectedInventory) {
            toastr["warning"]("Seleccione um inventário");
            return;
        }
        var JSONDetail = JSON.parse(myPatrimonyTool._canvasHtml.value);

        myPatrimonyTool._buildHtmlInventory(selectedInventory[0].numero_Invent, JSONDetail, $('#id-patrimony-type-element').val());
        myPatrimonyTool._GetDataInventoryInfo(selectedInventory[0].numero_Invent, $('#id-patrimony-type-element').val(), $('#id-patrimony-id-element').val());
    });

    /**
     * Build enventory information selected
     */
    $('#id-modal-select-flat-id-inv-select').on('click', function () {

        // Stop wait
        myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', true);

        var selectedAvailableFlatInventory = myPatrimonyTool._datatableAvailableFlatInventory.rows('.selected').data();

        if (selectedAvailableFlatInventory.length == 0 && selectedAssociateInventory.length == 0) {
            toastr["warning"]("Seleccione um inventário");
            return;
        }

        var listBuildingFlatInventory = [];
        for (var i = 0; i < selectedAvailableFlatInventory.length; i++) {
            listBuildingFlatInventory.push({ "inventario": selectedAvailableFlatInventory[i].numero_Invent });
        }

        var buildingFlatInventory = {
            "idEdificio": $('#id-patrimony-id-element').val(),
            "listBuildingFlatInventory": listBuildingFlatInventory
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/PatrimonyTool/AddBuildingFlatInventory',
            dataType: 'json',
            data: JSON.stringify(buildingFlatInventory),
            contentType: "application/json",
            success: function (data) {
                if (!data.result) {
                    toastr["error"]("Erro na adição de apartamentos ao edifício");
                }
                else
                {
                    switch (data.result.status) {
                        case "SUCCESS":
                            var inventory = $('#id-input-number-inv-patrimony-val').val();

                            var JSONDetail = JSON.parse(myPatrimonyTool._canvasHtml.value);

                            myPatrimonyTool._buildHtmlInventory(inventory, JSONDetail, $('#id-patrimony-type-element').val());
                            myPatrimonyTool._GetDataInventoryInfo(inventory, $('#id-patrimony-type-element').val(), $('#id-patrimony-id-element').val());

                            $('#id-modal-select-flat-id-inv').modal('hide');
                            break;
                        default:
                            toastr["error"]("Erro na adição de apartamentos ao edifício");
                            break;
                    }
                }

                // Stop wait
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na adição de apartamentos ao edifício");
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
            }
        });
    });


    /**
     * Save feature
     * @param {string} mode, write mode
     * @param {string} saveGeom, save geometry boolean
     */
    this._DeleteFeature = function (idPatrimony, layerName) {

        myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', true);

        $.ajax({
            type: 'DELETE',
            url: '/rest/app/PatrimonyTool/DeletePatrimony?idPatrimony=' + idPatrimony + '&layerName=' + layerName,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (!data.result) {
                    toastr["error"]("Erro ao remover camada");
                }
                else if (data.result) {

                    myPatrimonyTool._RefreshLayerPatrimony();

                    app.sgs.Map._utility.ShowCanvas(['id-offcanvas-layer-detail-patrimony'], false)

                    toastr["success"]("Sucesso ao remover camada");
                }

                // Stop wait
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);

            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao remover camada");
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
            }
        });
    };

    /**
     * Save feature
     * @param {string} mode, write mode
     * @param {string} saveGeom, save geometry boolean
     */
    this._SaveFeature = function (mode, saveGeom, layerName) {

        // Stop wait
        myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', true);

        var msgReturn = "";
        switch (mode) {
            case "update":
                msgReturn = "gravação";
                break;
            case "create":
                msgReturn = "criação";
                break;
            default:
            // do nothing
        }

        var flatCoordinates = myPatrimonyTool._featureInfo.feature.getGeometry().flatCoordinates;

        var Geom = "";

        var length = flatCoordinates.length - 1

        for (var t = 0; t < length; t++) {

            var i = t + 1;

            Geom += flatCoordinates[t] + ' ' + flatCoordinates[i] + ',';

            t++;
        }

        var data = {
            id: $('#id-patrimony-to-edit').val(),
            modo: mode,
            inventario: $('#id-input-number-inv-patrimony-val').val(),
            estatuto: $('#prop_estatuto').val(),
            idEdificio: $('#prop_ID').val(),
            alvara: $('#prop_alvara').val(),
            type_ground: $('#prop_type-ground').val(),
            geom_wkt: Geom.slice(0, -1),
            geom_srid: myPatrimonyTool._mapSgs._settings._mapSettings.map_info.srs_srid,
            layerName: layerName       
        }

        var stringObjet = JSON.stringify(data);

        $.ajax({
            type: 'POST',
            url: '/rest/app/PatrimonyTool/CreateEditNewEdificio',
            dataType: 'json',
            data: stringObjet,
            contentType: "application/json",
            success: function (data) {
                if (!data.result) {
                    toastr["error"]("Erro na " + msgReturn);
                }
                else if (data.result) {

                    // Refresh layer
                    myPatrimonyTool._RefreshLayerPatrimony();

                    // Close edition
                    app.sgs.Map._utility.ShowCanvas(['id-offcanvas-layer-detail-patrimony'], false)

                    $('#geometry-cancel').trigger('click');

                    toastr["success"]("Sucesso na " + msgReturn);
                }

                // Stop wait
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);

            },
            error: function (request, status, error) {
                toastr["error"]("Erro na " + msgReturn);
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
            }
        });
    };

    /**
     * Get inventoty information
     * @param {any} inventoryNumber
     */
    this._GetDataInventoryById = function (inventoryNumber) {

        if (inventoryNumber != " " && inventoryNumber != null) {

            $.ajax({
                type: 'GET',
                url: '/rest/app/PatrimonyTool/GetImoveisById?inventoryNumber=' + inventoryNumber,
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error)
                    {
                        toastr["error"]("Erro ao carregar informação do número de inventário");
                    }
                    else
                    {
                        $.each(data.result, function (index, value)
                        {
                            $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12 [data-name="' + index + '"]').val(value)
                        });
                    }

                    myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
                },
                error: function (request, status, error)
                {
                    toastr["warning"]("Erro ao carregar dados");
                    myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
                }
            });
        }
        else
        {
            myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
        }
    }

    /**
     * Get inventoty information
     * @param {any} inventoryNumber
     * @param {any} typeElement
     * @param {any} idElementInput
     */
    this._GetDataInventoryInfo = function (inventoryNumber, typeElement, idElementInput) {

        if (inventoryNumber != " " && inventoryNumber != null) {

            var idElement = (idElementInput == null || idElementInput == "") ? -1 : idElementInput;
            $.ajax({
                type: 'GET',
                url: '/rest/app/PatrimonyTool/GetInventoryInfo?inventoryNumber=' + inventoryNumber + "&typeElement=" + typeElement + "&idElement=" + idElement,
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro ao carregar informação do inventário");
                    }
                    else
                    {
                        switch (data.result.status) {
                            case "SUCCESS":
                                // Imoveis info
                                if (data.result.imoveisInfo != null) {
                                    $.each(data.result.imoveisInfo, function (index, value) {
                                        $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12 [data-name="' + index + '"]').val(value)
                                    });
                                }
                                // Bens info
                                if (data.result.bensInfo != null) {
                                    $.each(data.result.bensInfo, function (index, value) {
                                        $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12 [data-name="' + index + '"]').val(value)
                                    });
                                }
                                // Land info
                                if (data.result.landInfo != null) {
                                    $.each(data.result.landInfo, function (index, value) {
                                        $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12 [data-name="' + index + '"]').val(value)
                                    });
                                }
                                // Build info
                                if (data.result.buildingInfo != null) {
                                    $.each(data.result.buildingInfo, function (index, value) {
                                        $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12 [data-name="' + index + '"]').val(value)
                                    });
                                }
                                // Build flat info
                                if (data.result.buildingFlatInfo != null) {
                                    $.each(data.result.buildingFlatInfo, function (index, value) {
                                        $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12 [data-name="' + index + '"]').val(value)
                                    });
                                }

                                var listInfoSameInventory = null;
                                var listBuildingFlatInfo = null;
                                switch (typeElement) {
                                    case "EDIFICIOS":
                                        $('#id-offcanvas-body-layer-same-inventory label').html("Edifícios com o mesmo inventário");
                                        listInfoSameInventory = data.result.listBuildingInfoSameInventory.map(function (data) { return { "id": data.objectid, "inventario": data.inventario, "estatuto": data.estatuto }; })
                                        if (data.result.listBuildingFlatInfo)
                                            listBuildingFlatInfo = data.result.listBuildingFlatInfo.map(function (data) { return { "id": data.id, "idEdificio": data.idEdificio, "inventario": data.inventario, "descricao": data.descricao }; })
                                        break;
                                    case "TERRENOS":
                                        $('#id-offcanvas-body-layer-same-inventory label').html("Terrenos com o mesmo inventário");
                                        listInfoSameInventory = data.result.listLandInfoSameInventory.map(function (data) { return { "id": data.objectiD_12, "inventario": data.inventario, "estatuto": data.estatuto }; })
                                        break;
                                    default:
                                    // do nothing
                                }

                                // Same inventory
                                $('#id-offcanvas-body-layer-same-inventory').hide();
                                if (listInfoSameInventory && listInfoSameInventory.length > 0) {
                                    $('#id-offcanvas-body-layer-same-inventory').show();

                                    if (myPatrimonyTool._datatableSameInventory) {
                                        myPatrimonyTool._datatableSameInventory.destroy();
                                    }

                                    // -- init column def --
                                    var columnDefSameInventory = [];

                                    columnDefSameInventory.push({
                                        'data': 'id',
                                        'type': 'readonly',
                                        'visible': false
                                    });

                                    // inventario
                                    columnDefSameInventory.push({
                                        'id': 'inventario',
                                        'data': 'inventario',
                                        'type': 'readonly',
                                        'name': 'Inventário',
                                        'title': 'Inventário'
                                    });

                                    // tipo terreno
                                    columnDefSameInventory.push({
                                        'id': 'estatuto',
                                        'data': 'estatuto',
                                        'name': 'Estatuto',
                                        'type': 'readonly',
                                        'title': 'Estatuto'
                                    });

                                    // button
                                    columnDefSameInventory.push({
                                        'name': 'button_go_to_elemento',
                                        'className': 'dt-body-center dt-font',
                                        'data': null,
                                        'orderable': false,
                                        'render': function (data, type, row) {
                                            return '<a id-element = "' + data.id + '" class="offcanvas-body-same-inventory-container-table-goto button-config-element patrimony-go-to on-button"><i class="material-icons">location_on</i></a>';
                                        }
                                    });

                                    myPatrimonyTool._datatableSameInventory = $('#id-offcanvas-body-same-inventory-container-table').DataTable({
                                        "dom": 't',
                                        "destroy": true,
                                        "language": {
                                            "search": "Procurar",
                                            "emptyTable": 'Nenhum inventário encontrado',
                                            "paginate": {
                                                "previous": '<i class="fa fa-caret-left"></i>',
                                                "next": '<i class="fa fa-caret-right"></i>',
                                                "first": '<i class="fa fa-step-backward"></i>',
                                                "last": '<i class="fa fa-step-forward"></i>'
                                            }
                                        },
                                        "fixedHeader": false,
                                        "filter": true,
                                        "info": false,
                                        "scrollCollapse": true,
                                        "deferRender": false,
                                        "scroller": false,
                                        "ordering": false,
                                        "select": false,
                                        "bPaginate": false,
                                        "columns": columnDefSameInventory,
                                        "data": listInfoSameInventory,
                                        "name": "numero_Invent",
                                        "rowId": 'numero_Invent',
                                        "searchable": false,
                                        "lengthChange": false,
                                        "iDisplayLength": 10,
                                        "bStateSave": true
                                    });
                                    myPatrimonyTool._datatableSameInventory.on('draw', function () {
                                        $('.offcanvas-body-same-inventory-container-table-goto').on('click', function () {
                                            var id = $(this).attr("id-element");
                                            myPatrimonyTool._GotoInventory(id);
                                        });
                                    });
                                    myPatrimonyTool._datatableSameInventory.draw();
                                }

                                // List building flat
                                if (listBuildingFlatInfo && listBuildingFlatInfo.length > 0) {
                                    if (myPatrimonyTool._datatableBuildingFlat) {
                                        myPatrimonyTool._datatableBuildingFlat.destroy();
                                    }

                                    // -- init column def --
                                    var columnDefBuildingFlat = [];

                                    columnDefBuildingFlat.push({
                                        'data': 'id',
                                        'type': 'readonly',
                                        'visible': false
                                    });

                                    columnDefBuildingFlat.push({
                                        'data': 'idEdificio',
                                        'type': 'readonly',
                                        'visible': false
                                    });

                                    // inventario
                                    columnDefBuildingFlat.push({
                                        'id': 'inventario',
                                        'data': 'inventario',
                                        'type': 'readonly',
                                        'name': 'Inventário',
                                        'title': 'Inventário'
                                    });

                                    // descrição
                                    columnDefBuildingFlat.push({
                                        'id': 'descricao',
                                        'data': 'descricao',
                                        'type': 'readonly',
                                        'name': 'Descrição',
                                        'title': 'Descrição'
                                    });

                                    // button goto detail
                                    columnDefBuildingFlat.push({
                                        'name': 'button_go_to_elemento',
                                        'className': 'dt-body-center dt-font',
                                        'data': null,
                                        'orderable': false,
                                        'render': function (data, type, row) {
                                            return '<a id-element = "' + data.id + '" id-edificio = "' + data.idEdificio + '" inventory = "' + data.inventario + '" class="offcanvas-body-building-flat-container-table-goto button-config-element patrimony-go-to on-button"><i class="material-icons" style="font-size: 20px;">info</i></a>';
                                        }
                                    });

                                    // button remove
                                    columnDefBuildingFlat.push({
                                        'name': 'button_remove',
                                        'className': 'dt-body-center dt-font',
                                        'data': null,
                                        'orderable': false,
                                        'render': function (data, type, row) {
                                            return '<a id-element = "' + data.id + '" id-edificio = "' + data.idEdificio + '" inventory = "' + data.inventario + '" class="offcanvas-body-building-flat-container-table-remove button-config-element patrimony-go-to on-button"><i class="material-icons" style="font-size: 20px;">close</i></a>';
                                        }
                                    });

                                    myPatrimonyTool._datatableBuildingFlat = $('#id-offcanvas-body-building-flat-container-table').DataTable({
                                        "dom": 't',
                                        "destroy": true,
                                        "language": {
                                            "search": "Procurar",
                                            "emptyTable": 'Nenhum apartamento associado',
                                            "paginate": {
                                                "previous": '<i class="fa fa-caret-left"></i>',
                                                "next": '<i class="fa fa-caret-right"></i>',
                                                "first": '<i class="fa fa-step-backward"></i>',
                                                "last": '<i class="fa fa-step-forward"></i>'
                                            }
                                        },
                                        "fixedHeader": false,
                                        "filter": true,
                                        "info": false,
                                        "scrollCollapse": true,
                                        "deferRender": false,
                                        "scroller": false,
                                        "ordering": false,
                                        "select": false,
                                        "bPaginate": false,
                                        "columns": columnDefBuildingFlat,
                                        "data": listBuildingFlatInfo,
                                        "name": "numero_Invent",
                                        "rowId": 'numero_Invent',
                                        "searchable": false,
                                        "lengthChange": false,
                                        "iDisplayLength": 10,
                                        "bStateSave": true
                                    });
                                    myPatrimonyTool._datatableBuildingFlat.on('draw', function () {
                                        $('.offcanvas-body-building-flat-container-table-goto').on('click', function () {
                                            var id = $(this).attr("id-element");
                                            var inventory = $(this).attr("inventory");
                                            myPatrimonyTool._GotoBuildingFlat(id, inventory, "EDIFICIOS_APARTAMENTO");
                                        });
                                        $('.offcanvas-body-building-flat-container-table-remove').on('click', function () {
                                            var id = $(this).attr("id-element");
                                            myPatrimonyTool._RemoveBuildingFlat(id);
                                        });
                                    });
                                    myPatrimonyTool._datatableBuildingFlat.draw();
                                }
                                break;
                            default:
                                toastr["error"]("Erro ao carregar informação do inventário");
                        }
                    }

                    myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro ao carregar informação do inventário");
                    myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
                }
            });
        }
        else {
            myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
        }
    }

    /**
     * Go to Inventory
     */
    this._GotoInventory = function (idsString)
    {
        var LayerJSON = myPatrimonyTool._mapSgs._utility.GetPropertyInfoInConfigArray(myPatrimonyTool._mapSgs._settings.configurationInfo.propertyInfo, "PATRIMONY", "SEARCH", "LAYER_JSON");
        var LayerParse = JSON.parse(LayerJSON.value).LAYER_JSON
        var getFeatureUrl = myPatrimonyTool._mapSgs._settings.searchToponymy.geoserverSearchToponymy + "/wfs";
        var LayerFound = false;
        var countLength = 0;

        for (var i = 0; i < LayerParse.length; i++)
        {
            countLength = i + 1;
            if (!LayerFound)
            {
                // Call geoserver to get the feature of the layer
                var getFeature = $.ajax({
                    method: "GET",
                    async: false,
                    url: getFeatureUrl,
                    data: {
                        "service": 'wfs',
                        "version": '2.0.0',
                        "request": 'GetFeature',
                        "typeNames": LayerParse[i].layer,
                        "featureID": idsString,
                        "propertyName": LayerParse[i].Geom,
                        "outputFormat": 'application/json',
                    }
                });

                // Response from the server
                getFeature.done(function (data, textStatus, jqXHR) {
                    myPatrimonyTool._mapSgs.layerHighlightOverlay.getSource().clear();
                    if (data.features) {
                        if (data.features.length > 0)
                        {
                            LayerFound = true;

                            for (var i = 0; i < data.features.length; i++) {

                                myPatrimonyTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[i]);
                                var styleElement = myPatrimonyTool._mapSgs._defaultHighlighStyles;
                                myPatrimonyTool._mapSgs.featureToHighLight.getArray()[myPatrimonyTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                            }
                            // Go to Feature
                            myPatrimonyTool._mapSgs.map.getView().fit(myPatrimonyTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myPatrimonyTool._mapSgs.map.getSize(), duration: 1000, maxZoom: 13 });

                            if (myPatrimonyTool._mapSgs._utility.mobilecheck())
                            {
                                $('#map-search').removeClass('active');
                                $('#map-search').css({ 'transform': 'none' });
                            }
                        }
                        else
                        {
                            if (countLength == LayerParse.length)
                                toastr["warning"]("Nenhum objeto encontrado");
                        }
                    }
                });
            }
        }
    }

    /**
     * Go to building flag info
     */
    this._GotoBuildingFlat = function (idElement, inventory, typeElement) {

        $('.hide-patrimony-building-flat').show();
        $('.show-patrimony-building-flat').hide();
        $('#id-offcanvas-head-title-element-patrimony')[0].innerHTML = "Apartamento";

        var JSONDetail = JSON.parse(myPatrimonyTool._canvasHtml.value);
        myPatrimonyTool._buildHtmlInventory(inventory, JSONDetail, typeElement);
        myPatrimonyTool._GetDataInventoryInfo(inventory, typeElement, idElement);
    }

    /**
     * Remove building flag info
     */
    this._RemoveBuildingFlat = function (idBuildingFlat) {

        myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', true);

        $.ajax({
            type: 'DELETE',
            url: '/rest/app/PatrimonyTool/DeletePatrimonyBuildingFlat?idBuildingFlat=' + idBuildingFlat,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (!data.result) {
                    toastr["error"]("Erro ao remover apartamento");
                }
                else
                {
                    switch (data.result.status) {
                        case "SUCCESS":
                            var inventory = $('#id-input-number-inv-patrimony-val').val();
                            var JSONDetail = JSON.parse(myPatrimonyTool._canvasHtml.value);

                            myPatrimonyTool._buildHtmlInventory(inventory, JSONDetail, $('#id-patrimony-type-element').val());
                            myPatrimonyTool._GetDataInventoryInfo(inventory, $('#id-patrimony-type-element').val(), $('#id-patrimony-id-element').val());
                            break;
                        default:
                            toastr["error"]("Erro na adição de apartamentos ao edifício");
                            break;
                    }
                }

                // Stop wait
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);

            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao remover apartamento");
                myPatrimonyTool._utility.ShowWait('id-offcanvas-layer-detail-patrimony-spinner', false);
            }
        });
    }

    /**
     * Build inventory information of edifício/terreno
     * @param {any} InventoryID
     * @param {any} JSONDetail
     * @param {any} mode
     */
    this._buildHtmlInventory = function (InventoryID, JSONDetail, typeElement, mode)
    {
        let container = $('#id-offcanvas-layer-detail-patrimony .offcanvas-body-layer-detail.content-layer-detail > div.col-md-12');

        // -- N.º Inventário ----------------------------------------------------------------------
        $('#id-offcanvas-body-layer-id-inv').remove();

        container.append('<div id="id-offcanvas-body-layer-id-inv" class="row margin-top-lg offcanvas-body-layer-detail" > '
            + '<div class="col-md-12" style="text-align: center;">'
            + '<div>'
            + '<div>'
            + '<i class="option-title-go-right-open"></i>'
            + '<label>N.º Inventário</label>'
            + '</div>'
            + '<button type="button" data-name="numero_Invent" class="btn btn-primary" id="id-input-number-inv-patrimony" style="margin-bottom: 20px;text-align: center;"> ' + InventoryID + ' </button>'
            + '<input type="hidden" id="id-input-number-inv-patrimony-val" value="' + InventoryID + '" />'
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        if (InventoryID == " " || InventoryID == "" || InventoryID == null)
        {
            $('#id-offcanvas-body-layer-local').remove();
            $('#id-offcanvas-body-layer-description').remove();
            $('#id-offcanvas-body-layer-info').remove();

            if (mode != null || mode == 'create')
            {
                if (typeElement !=="EDIFICIOS_APARTAMENTO")
                    myPatrimonyTool._EventsOnClick();

                return $('#id-input-number-inv-patrimony').html('Associar');
            }
            else
            {
                return toastr["warning"]("Edifício/terreno não contem nº de inventário");
            }
        }

        // -- List of edificio/tereeno with the same inventory ------------------------------------
        $('#id-offcanvas-body-layer-same-inventory').remove();
        if (myPatrimonyTool._datatableSameInventory) {
            myPatrimonyTool._datatableSameInventory.destroy();
        }

        let localContentSameInventory = '<div id="id-offcanvas-body-layer-detail-same-inventory" class="offcanvas-block" style="display: none;">'
            + '<div class="table-responsive">'
            + '<div id="id-offcanvas-body-same-inventory-container" class="body table-responsive">'
            + '<table id="id-offcanvas-body-same-inventory-container-table" width="100%"></table>'
            + '</div>'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-same-inventory" class="row margin-top-lg offcanvas-body-layer-detail" style="display: none;">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-same-inventory" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Terrenos/Edifício com o mesmo inventário</label>'
            + '</div>'
            + localContentSameInventory
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        // -- List of building flat inventory ------------------------------------
        $('#id-offcanvas-body-layer-building-flat').remove();
        if (typeElement == "EDIFICIOS") {
            if (myPatrimonyTool._datatableBuildingFlat) {
                myPatrimonyTool._datatableBuildingFlat.destroy();
            }

            let localContentBuildingFlat = '<div id="id-offcanvas-body-layer-detail-building-flat" class="offcanvas-block" style="display: none;">'
                + '<div class="table-responsive">'
                + '<div style="text-align: center">'
                + '<button type="button" data-name="add-flat" class="btn btn-primary" id="id-add-building-flat-inventory" style="margin-bottom: 20px;text-align: center;font-size: 10px;padding: 3px 8px;"><i class="fa fa-plus-circle" style="padding-right: 10px;"></i>Adicionar</button>'
                + '</div>'
                + '<div id="id-offcanvas-body-building-flat-container" class="body table-responsive">'
                + '<table id="id-offcanvas-body-building-flat-container-table" width="100%"></table>'
                + '</div>'
                + '</div>'
                + '</div>';

            container.append('<div id="id-offcanvas-body-layer-building-flat" class="row margin-top-lg offcanvas-body-layer-detail">'
                + '<div class="col-md-12">'
                + '<div>'
                + '<div target-id="id-offcanvas-body-layer-detail-building-flat" class="offcanvas-collapse">'
                + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                + '<label>Apartamentos</label>'
                + '</div>'
                + localContentBuildingFlat
                + '</div>'
                + '<div class="offcanvas-separator"></div>'
                + '</div>'
                + '</div>');
        }

        // -- Localização -------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-local').remove();

        let localContentLocal = '<div id="id-offcanvas-body-layer-detail-local" class="offcanvas-block" style="display: none;">'
            + '<div class="table-responsive">'
            + '<div id="id-offcanvas-body-local-container" class="body table-responsive">'
            + '</div>'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-local" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-local" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Localização</label>'
            + '</div>'
            + localContentLocal
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        $.each(JSONDetail["Localização"], function (i, item)
        {
            $('#id-offcanvas-body-local-container').append($(
                '<div class="form-group offcanvas-body-layer-detail-row">'
                + '<label for="prop_' + item.column_name + '">' + item.pretty_name + '</label>'
                + '<input class=" feature-field form-control ' + item.column_name + '" data-name="' + item.column_name + '" type="text" id="prop_' + item.column_name + '"/>'
                + '</div > '
            ));
        });

        // -- Caracterização -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-description').remove();

        let localContentDescription = '<div id="id-offcanvas-body-layer-detail-description" class="offcanvas-block" style="display: none;">'
            + '<div class="table-responsive">'
            + '<div id="id-offcanvas-body-description-container" class="body table-responsive">'
            + '</div>'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-description" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-description" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Caracterização</label>'
            + '</div>'
            + localContentDescription
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        $.each(JSONDetail["Caracterização"], function (i, item)
        {
            $('#id-offcanvas-body-description-container').append($(
                '<div class="form-group offcanvas-body-layer-detail-row">'
                + '<label for="prop_' + item.column_name + '">' + item.pretty_name + '</label>'
                + '<input class=" feature-field form-control ' + item.column_name + '" data-name="' + item.column_name + '" type="text" id="prop_' + item.column_name + '"/>'
                + '</div > '
            ));
        });

        // -- Outras Informações -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-info').remove();

        let localContentInfo = '<div id="id-offcanvas-body-layer-detail-info" class="offcanvas-block" style="display: none;">'
            + '<div class="table-responsive">'
            + '<div id="id-offcanvas-body-info-container" class="body table-responsive">'
            + '</div>'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-info" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-info" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Outras Informações</label>'
            + '</div>'
            + localContentInfo
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        $.each(JSONDetail["Outras Informações"], function (i, item)
        {
            $('#id-offcanvas-body-info-container').append($(
                '<div class="form-group offcanvas-body-layer-detail-row">'
                + '<label for="prop_' + item.column_name + '">' + item.pretty_name + '</label>'
                + '<input class=" feature-field form-control ' + item.column_name + '" data-name="' + item.column_name + '" type="text" id="prop_' + item.column_name + '"/>'
                + '</div > '
            ));
        });

        $('#id-div-canvas-body-detail-patrimony .offcanvas-collapse').off('click').on('click', function (e) {

            e.preventDefault();

            var IconHtml = $(this).find('i')[0]

            var targetId = this.getAttribute('target-id');

            $('#' + targetId).toggle('ol-hidden')

            if ($(IconHtml).hasClass('fa-chevron-down'))
                $($(this).find('i')[0]).removeClass('fa-chevron-down').addClass('fa-chevron-up')
            else
                $($(this).find('i')[0]).removeClass('fa-chevron-up').addClass('fa-chevron-down')
        });

        $('#id-modal-select-new-id-inv').modal('hide');

        // Evento on open/close modal list/select inventory
        if (typeElement !== "EDIFICIOS_APARTAMENTO")
            myPatrimonyTool._EventsOnClick();
    }

    /**
     * Define evento on open/close modal list/select inventory
     */
    this._EventsOnClick = function () {

        /**
         * Open model list of all inventory number
         */
        $('#id-input-number-inv-patrimony').off('click').on('click', function () {

            myPatrimonyTool._utility.ShowWait('id-modal-select-new-inv-spinner', true);

            $.ajax({
                type: 'GET',
                url: '/rest/app/PatrimonyTool/GetAllNumberInventory',
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro ao obter a informação de inventário");
                    }
                    else {
                        switch (data.result.status) {
                            case "SUCCESS":
                                // Available inventory
                                if (data.result.listAvailableInventory != null && data.result.listAvailableInventory.length > 0) {
                                    myPatrimonyTool._datatableAvailableInventory.clear();
                                    myPatrimonyTool._datatableAvailableInventory.rows.add(data.result.listAvailableInventory);
                                    myPatrimonyTool._datatableAvailableInventory.draw();
                                }
                                // Associate inventory
                                if (data.result.listAssociateInventory != null && data.result.listAssociateInventory.length > 0) {
                                    myPatrimonyTool._datatableAssociateInventory.clear();
                                    myPatrimonyTool._datatableAssociateInventory.rows.add(data.result.listAssociateInventory);
                                    myPatrimonyTool._datatableAssociateInventory.draw();
                                }
                                break;
                            default:
                                toastr["error"]("Erro ao obter a informação de inventário");
                        }
                    }

                    myPatrimonyTool._utility.ShowWait('id-modal-select-new-inv-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro ao obter a informação de inventário");
                    myPatrimonyTool._utility.ShowWait('id-modal-select-new-inv-spinner', false);
                }
            });



            $('#id-modal-select-new-id-inv').modal('show');

        });

        /**
         * Close model list of all inventory number
         */
        $('#id-modal-select-new-id-inv-close').off('click').on('click', function () {
            $('#id-modal-select-new-id-inv').modal('hide');
        });

        /**
         * Open model list of all flat inventory number
         */
        $('#id-add-building-flat-inventory').off('click').on('click', function () {

            myPatrimonyTool._utility.ShowWait('id-modal-select-flat-inv-spinner', true);

            $.ajax({
                type: 'GET',
                url: '/rest/app/PatrimonyTool/GetAllNumberFlatInventory',
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro ao obter a informação de inventário");
                    }
                    else {
                        switch (data.result.status) {
                            case "SUCCESS":
                                // Available flat inventory
                                if (data.result.listAvailableInventory != null && data.result.listAvailableInventory.length > 0) {
                                    myPatrimonyTool._datatableAvailableFlatInventory.clear();
                                    myPatrimonyTool._datatableAvailableFlatInventory.rows.add(data.result.listAvailableInventory);
                                    myPatrimonyTool._datatableAvailableFlatInventory.draw();
                                }
                                break;
                            default:
                                toastr["error"]("Erro ao obter a informação de inventário");
                        }
                    }

                    myPatrimonyTool._utility.ShowWait('id-modal-select-flat-inv-spinner', false);
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro ao obter a informação de inventário");
                    myPatrimonyTool._utility.ShowWait('id-modal-select-flat-inv-spinner', false);
                }
            });

            $('#id-modal-select-flat-id-inv').modal('show');

        });

        /**
         * Close model list of all flat inventory number
         */
        $('#id-modal-select-flat-id-inv-close').off('click').on('click', function () {
            $('#id-modal-select-flat-id-inv').modal('hide');
        });
    }

    /**
     * Refresh deposition layer
     */
    this._RefreshLayerPatrimony = function ()
    {
        var view = myPatrimonyTool._mapSgs.map.getView();
        var zoom = myPatrimonyTool._mapSgs.map.getView().getZoom();
        view.animate({
            zoom: zoom - 1,
            duration: 1000
        });
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    $('#id-return-patrimony-building').off('click').on('click', function () {
        $('.hide-patrimony-building-flat').hide();
        $('.show-patrimony-building-flat').show();
        $('#id-offcanvas-head-title-element-patrimony')[0].innerHTML = "Edifício";

        var inventory = $('#id-patrimony-inventory-building-of-flat').val();
        var JSONDetail = JSON.parse(myPatrimonyTool._canvasHtml.value);

        myPatrimonyTool._buildHtmlInventory(inventory, JSONDetail, $('#id-patrimony-type-element').val());
        myPatrimonyTool._GetDataInventoryInfo(inventory, $('#id-patrimony-type-element').val(), $('#id-patrimony-id-element').val());
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init deposition point tool
 * @param {object} mapSgs, map object
 */
PatrimonyTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        var this_ = this;

        // Set map info
        this._mapSgs = mapSgs;

        // -- Init upload -------------------------------------------------------------------------
        if (this._mapSgs._settings._mapSettings.operation_visible.Upload)
        {
            this._uploadAttachtment = new Upload(this._mapSgs._settings._mapSettings.user_info.id_user);
            this._uploadAttachtment._fileEditorTemplate =  this._fileEditorTemplateForEquipment;
            this._uploadAttachtment._fileEditorTemplateFileZoneDivWithExpand = this._fileEditorTemplateFileZoneDivWithExpandForEquipment;
            this._uploadAttachtment._fileEditorTemplateFileZoneDivNoExpand = this._fileEditorTemplateFileZoneDivNoExpandForEquipment;
        }

        // -- Available inventory --

        // -- init column def --
        var columnDefGroupTemplateAI = [];

        // numero_Invent
        columnDefGroupTemplateAI.push({
            'id': 'numero_Invent',
            'data': 'numero_Invent',
            'type': 'readonly',
            'name': 'Inventário',
            'title': 'Inventário'
        });

        // name
        columnDefGroupTemplateAI.push({
            'id': 'descricao',
            'data': 'descricao',
            'name': 'Imóvel',
            'type': 'readonly',
            'title': 'Imóvel'
        });

        // name
        columnDefGroupTemplateAI.push({
            'id': 'localizacao',
            'data': 'localizacao',
            'name': 'Localização',
            'type': 'readonly',
            'title': 'Localização'
        });

        // name
        columnDefGroupTemplateAI.push({
            'id': 'area_total',
            'data': 'area_total',
            'name': 'Área Total',
            'type': 'readonly',
            'title': 'Área Total'
        });

        this._datatableAvailableInventory = $('#id-datatable-available-inventory').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum inventário encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": true,
            "bPaginate": true,
            "columns": columnDefGroupTemplateAI,
            "name": "numero_Invent",
            "rowId": 'numero_Invent',
            "searchable": true,
            "lengthChange": false,
            "iDisplayLength": 10,
            "bStateSave": true
        });

        this._datatableAvailableInventory.on('select', function () {
            this_._datatableAssociateInventory.rows().deselect();
        });

        // -- Associate inventory --

        // -- init column def --
        var columnDefGroupTemplateASI = [];

        // numero_Invent
        columnDefGroupTemplateASI.push({
            'id': 'numero_Invent',
            'data': 'numero_Invent',
            'type': 'readonly',
            'name': 'Inventário',
            'title': 'Inventário'
        });

        // name
        columnDefGroupTemplateASI.push({
            'id': 'descricao',
            'data': 'descricao',
            'name': 'Imóvel',
            'type': 'readonly',
            'title': 'Imóvel'
        });

        // name
        columnDefGroupTemplateASI.push({
            'id': 'localizacao',
            'data': 'localizacao',
            'name': 'Localização',
            'type': 'readonly',
            'title': 'Localização'
        });

        // name
        columnDefGroupTemplateASI.push({
            'id': 'area_total',
            'data': 'area_total',
            'name': 'Área Total',
            'type': 'readonly',
            'title': 'Área Total'
        });

        this._datatableAssociateInventory = $('#id-datatable-associate-inventory').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum inventário encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": true,
            "bPaginate": true,
            "columns": columnDefGroupTemplateASI,
            "name": "numero_Invent",
            "rowId": 'numero_Invent',
            "searchable": true,
            "lengthChange": false,
            "iDisplayLength": 10,
            "bStateSave": true
        });

        this._datatableAssociateInventory.on('select', function () {
            this_._datatableAvailableInventory.rows().deselect();
        });

        // -- Available flat inventory --

        // -- init column def --
        var columnDefGroupTemplateFlat = [];

        // numero_Invent
        columnDefGroupTemplateFlat.push({
            'id': 'numero_Invent',
            'data': 'numero_Invent',
            'type': 'readonly',
            'name': 'Inventário',
            'title': 'Inventário'
        });

        // name
        columnDefGroupTemplateFlat.push({
            'id': 'descricao',
            'data': 'descricao',
            'name': 'Imóvel',
            'type': 'readonly',
            'title': 'Imóvel'
        });

        // name
        columnDefGroupTemplateFlat.push({
            'id': 'localizacao',
            'data': 'localizacao',
            'name': 'Localização',
            'type': 'readonly',
            'title': 'Localização'
        });

        // name
        columnDefGroupTemplateFlat.push({
            'id': 'area_total',
            'data': 'area_total',
            'name': 'Área Total',
            'type': 'readonly',
            'title': 'Área Total'
        });

        this._datatableAvailableFlatInventory = $('#id-datatable-available-flat-inventory').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum inventário encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "select": true,
            "bPaginate": true,
            "columns": columnDefGroupTemplateFlat,
            "name": "numero_Invent",
            "rowId": 'numero_Invent',
            "searchable": true,
            "lengthChange": false,
            "iDisplayLength": 10,
            "bStateSave": true
        });
    }
};